import React from "react";
import "./addCataloguePackageFeatureDetails.css";
import Select from "react-select";
import { FormControl } from "react-bootstrap";
import CustomCheckbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const CataloguePackageFeatureDetailsForm = (props) => {
  const {
    featureDetails,
    setFeatureDetails,
    addSpecialtyRow,
    onChangeTags,
    onChangeTier,
    tagListOption,
    couponList,
    groupData,
    specialtyListOption,
    doctorListOption,
    onSpecialityChange,
    onCallChange,
    handleAllCheckedFreeDelivery,
    deliveryWelcomeNote,
    setDeliveryWelcomeNote,
    noOfFreeDelivery,
    setNoOfFreeDelivery,
    noOfFreeValue,
    setNoOfFreeValue,
    tags,
    selectedTiers,
    selectedTags,
    setSelectedTags,
    setSelectedTiers,
    onCouponAdd,
    onRemoveCoupon,
    onGroupAdd,
    onGroupRemove,
    updateClaimField,
    updatePolicyField,
    toggleClaimCheckbox,
    onDoctorChange,
    onDoctorCallChange,
    addDoctorRow,
    removeDoctorRow,
    removeSpecialtyRow,
    processing,
    packageNameError,
    packageDurationError,
    packagePriceError,
    countryError,
    claimValueError,
    bankChargeError,
    brokerEmailError,
    onCallUnlimitedChange,
    ipdClaimValueError,
    dashboardUrl,
    setDashboardUrl,
  } = props;

  const isCheckedValue = (value) =>
    value === true || value === "true" || value === 1 || value === "1";

  const updateYourHealthOption = (index, key, checked) => {
    const updatedFeatures = [...featureDetails];
    const currentValue =
      updatedFeatures[index].input_value &&
      typeof updatedFeatures[index].input_value === "object"
        ? updatedFeatures[index].input_value
        : {};

    updatedFeatures[index].input_value = {
      flashOneAvailable: false,
      periodTrackerAvailable: false,
      ...currentValue,
      [key]: checked,
    };
    setFeatureDetails(updatedFeatures);
  };

  const updateClaimPricingSlab = (index, slabIndex, field, value) => {
    const updatedFeatures = [...featureDetails];
    const slabs = Array.isArray(updatedFeatures[index].claimPricingSlabs)
      ? [...updatedFeatures[index].claimPricingSlabs]
      : [{ fromClaimCount: "", toClaimCount: "", price: "" }];

    slabs[slabIndex] = {
      ...slabs[slabIndex],
      [field]: value,
    };
    updatedFeatures[index].claimPricingSlabs = slabs;
    setFeatureDetails(updatedFeatures);
  };

  const addClaimPricingSlab = (index) => {
    const updatedFeatures = [...featureDetails];
    const slabs = Array.isArray(updatedFeatures[index].claimPricingSlabs)
      ? [...updatedFeatures[index].claimPricingSlabs]
      : [];

    slabs.push({ fromClaimCount: "", toClaimCount: "", price: "" });
    updatedFeatures[index].claimPricingSlabs = slabs;
    setFeatureDetails(updatedFeatures);
  };

  const removeClaimPricingSlab = (index, slabIndex) => {
    const updatedFeatures = [...featureDetails];
    const slabs = Array.isArray(updatedFeatures[index].claimPricingSlabs)
      ? [...updatedFeatures[index].claimPricingSlabs]
      : [];

    updatedFeatures[index].claimPricingSlabs =
      slabs.length > 1
        ? slabs.filter((item, idx) => idx !== slabIndex)
        : [{ fromClaimCount: "", toClaimCount: "", price: "" }];
    setFeatureDetails(updatedFeatures);
  };

  return (
    <div>
      {/* <div className="form-section">
        <div className="section-header">
          <h4>
            <i className="fa fa-list"></i>
            Feature Details
          </h4>
        </div> */}
      <div className="section-content">
        <div className="features-grid">
          {featureDetails.map((feature, index) => (
            <div className="feature-card" key={feature.id}>
              <div className="feature-checkbox">
                <input
                  type="checkbox"
                  id={`feature-${feature.id}`}
                  checked={feature.checked}
                  onChange={(e) => {
                    const updatedFeatures = [...featureDetails];
                    updatedFeatures[index].checked = e.target.checked;
                    if (feature.label === "Your Health") {
                      updatedFeatures[index].input_value = e.target.checked
                        ? {
                            flashOneAvailable:
                              feature.input_value &&
                              feature.input_value.flashOneAvailable
                                ? feature.input_value.flashOneAvailable
                                : false,
                            periodTrackerAvailable:
                              feature.input_value &&
                              feature.input_value.periodTrackerAvailable
                                ? feature.input_value.periodTrackerAvailable
                                : false,
                          }
                        : {
                            flashOneAvailable: false,
                            periodTrackerAvailable: false,
                          };
                    }
                    if (
                      feature.label === "Talk later speciality" &&
                      !e.target.checked
                    ) {
                      updatedFeatures[index].input_value = [
                        { specialty: "", noOfCalls: "" },
                      ];
                    }
                    if (
                      feature.label === "Talk Later Doctor wise" &&
                      e.target.checked
                    ) {
                      updatedFeatures[index].input_value = [
                        { doctors: null, no_of_calls: "" },
                      ];
                    }
                    if (
                      feature.label === "Talk Later Doctor wise" &&
                      !e.target.checked
                    ) {
                      updatedFeatures[index].input_value = [];
                    }
                    if (feature.label === "Delivery" && !e.target.checked) {
                      handleAllCheckedFreeDelivery(false, index);
                    }
                    // if (feature.label === "Claim Module" && e.target.checked) {
                    //   // Prime claim defaults in a single state write to avoid race conditions

                    // }

                    setFeatureDetails(updatedFeatures);
                  }}
                />
                <label htmlFor={`feature-${feature.id}`}>{feature.label}</label>
              </div>
              {feature.label === "Your Health" && feature.checked ? (
                <div className="your-health-inline-options">
                  <div className="flash-credit-control">
                    <label
                      className="flash-credit-toggle"
                      htmlFor={`flashOneAvailable-${feature.id}`}
                    >
                      <input
                        type="checkbox"
                        id={`flashOneAvailable-${feature.id}`}
                        checked={
                          (feature.input_value &&
                            feature.input_value.flashOneAvailable) ||
                          false
                        }
                        onChange={(e) =>
                          updateYourHealthOption(
                            index,
                            "flashOneAvailable",
                            e.target.checked,
                          )
                        }
                      />
                      <span className="flash-credit-box" aria-hidden="true" />
                      <span className="flash-credit-text">
                        Flash One Available
                      </span>
                    </label>
                  </div>
                  <div className="flash-credit-control">
                    <label
                      className="flash-credit-toggle"
                      htmlFor={`periodTrackerAvailable-${feature.id}`}
                    >
                      <input
                        type="checkbox"
                        id={`periodTrackerAvailable-${feature.id}`}
                        checked={
                          (feature.input_value &&
                            feature.input_value.periodTrackerAvailable) ||
                          false
                        }
                        onChange={(e) =>
                          updateYourHealthOption(
                            index,
                            "periodTrackerAvailable",
                            e.target.checked,
                          )
                        }
                      />
                      <span className="flash-credit-box" aria-hidden="true" />
                      <span className="flash-credit-text">
                        Period Tracker Available
                      </span>
                    </label>
                  </div>
                </div>
              ) : feature.label === "Talk later speciality" &&
                feature.checked ? (
                <>
                  {feature.input_value.map((speciality, specIndex) => (
                    <div className="speciality-row" key={specIndex}>
                      <Select
                        placeholder="Select Specialities"
                        options={specialtyListOption}
                        className="speciality-select"
                        classNamePrefix="select"
                        value={speciality.specialty || null}
                        onChange={(selected) => {
                          onSpecialityChange(selected, index, specIndex);
                        }}
                      />
                      <FormControl
                        type="text"
                        placeholder="Enter number of calls"
                        className="form-control speciality-input"
                        value={speciality.noOfCalls}
                        onChange={(e) => {
                          onCallChange(e, index, specIndex);
                        }}
                        disabled={speciality.unlimited}
                      />
                      {/* add custom checkbox for unlimited calls */}
                      <CustomCheckbox
                        number={specIndex + 5000}
                        checked={speciality.unlimited || false}
                        onChange={(e) =>
                          onCallUnlimitedChange(e, index, specIndex)
                        }
                        label="Unlimited Calls"
                      />
                      <div className="speciality-actions">
                        <button
                          type="button"
                          className="speciality-btn speciality-close"
                          onClick={() => {
                            removeSpecialtyRow(index, specIndex);
                          }}
                        >
                          <i className="fa fa-close"></i>
                        </button>
                        {specIndex === feature.input_value.length - 1 && (
                          <button
                            type="button"
                            className="speciality-btn speciality-add"
                            onClick={() => {
                              addSpecialtyRow(index);
                            }}
                          >
                            Add
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </>
              ) : feature.label === "Delivery" && feature.checked ? (
                <div className="delivery-block">
                  <div className="delivery-top">
                    <FormControl
                      type="text"
                      placeholder="No Of Free Delivery"
                      className="delivery-input"
                      value={noOfFreeDelivery || ""}
                      onChange={(e) => {
                        // only i want add positive number
                        const value = e.target.value;
                        if (value === "" || /^[0-9\b]+$/.test(value)) {
                          setNoOfFreeDelivery(value);
                          const updated = [...featureDetails];
                          updated[index].noOfFreeDelivery = value;
                          setFeatureDetails(updated);
                        }
                      }}
                    />
                    <FormControl
                      type="text"
                      placeholder="Enter the welcome note"
                      className="delivery-input"
                      value={deliveryWelcomeNote || ""}
                      onChange={(e) => {
                        setDeliveryWelcomeNote(e.target.value);
                        const updated = [...featureDetails];
                        updated[index].deliveryWelcomeNote = e.target.value;
                        setFeatureDetails(updated);
                      }}
                    />
                  </div>
                  {feature.input_value.map((option, dIdx) => {
                    const enabled =
                      option.enabled !== undefined && option.enabled !== null
                        ? option.enabled
                        : false;
                    const typeLabel =
                      option.type === "standard"
                        ? "Standard"
                        : option.type === "express"
                          ? "Express"
                          : option.type === "island_wide"
                            ? "Island Wide"
                            : option.type || `Option ${dIdx + 1}`;

                    const handleToggle = (checked) => {
                      const updated = [...featureDetails];
                      const item = { ...updated[index].input_value[dIdx] };
                      item.enabled = checked;
                      if (!checked) {
                        item.free = null;
                        item.discount = null;
                        item.base_price = null;
                      }
                      updated[index].input_value[dIdx] = item;
                      setFeatureDetails(updated);
                    };

                    const handleFieldChange = (key, value) => {
                      const updated = [...featureDetails];
                      const item = { ...updated[index].input_value[dIdx] };
                      item[key] = value;
                      item.enabled = true;
                      updated[index].input_value[dIdx] = item;
                      setFeatureDetails(updated);
                    };

                    return (
                      <div className="delivery-row" key={option.type || dIdx}>
                        <div className="delivery-header">
                          <label className="delivery-toggle">
                            <input
                              type="checkbox"
                              checked={enabled}
                              onChange={(e) => handleToggle(e.target.checked)}
                            />
                            <span className="delivery-toggle-text">
                              {typeLabel}
                            </span>
                          </label>
                        </div>
                        {enabled && (
                          <div className="delivery-fields">
                            <FormControl
                              type="text"
                              placeholder="No of Free"
                              value={
                                option.free !== undefined &&
                                option.free !== null
                                  ? option.free
                                  : ""
                              }
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "" || /^[0-9\b]+$/.test(value)) {
                                  handleFieldChange("free", value);
                                }
                              }}
                              className="delivery-input"
                            />
                            <FormControl
                              type="text"
                              placeholder="Discount"
                              value={
                                option.discount !== undefined &&
                                option.discount !== null
                                  ? option.discount
                                  : ""
                              }
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "" || /^[0-9\b]+$/.test(value)) {
                                  handleFieldChange("discount", value);
                                }
                              }}
                              className="delivery-input"
                            />
                            <FormControl
                              type="text"
                              placeholder="Base Price"
                              value={
                                option.base_price !== undefined &&
                                option.base_price !== null
                                  ? option.base_price
                                  : ""
                              }
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "" || /^[0-9\b]+$/.test(value)) {
                                  handleFieldChange("base_price", value);
                                }
                              }}
                              className="delivery-input"
                            />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ) : feature.label === "Partner & Coupon Management" &&
                feature.checked ? (
                <div className="partner-coupon-block">
                  {(() => {
                    const tierOptions = feature.tierOptions || [
                      { value: "platinum", label: "Platinum" },
                      { value: "gold", label: "Gold" },
                      { value: "silver", label: "Silver" },
                      { value: "browns", label: "Browns" },
                    ];
                    const rawSelectedCoupons = feature.selectedCoupons || [];

                    const toCouponDisplay = (item) => {
                      const id = item && item.id !== undefined ? item.id : item;
                      const match = couponList.find(
                        (c) => String(c.id) === String(id),
                      );
                      const label =
                        (match && (match.label || match.title)) ||
                        (item && (item.label || item.title)) ||
                        id;
                      const title =
                        (match && (match.title || match.label)) ||
                        (item && (item.title || item.label)) ||
                        label;
                      return { id, label, title };
                    };

                    const selectedCoupons =
                      rawSelectedCoupons.map(toCouponDisplay);

                    return (
                      <>
                        <div className="partner-row">
                          <select
                            className="form-control"
                            disabled={!feature.checked}
                            value={selectedTiers || ""}
                            onChange={(e) => onChangeTier(e, index)}
                          >
                            <option value="">Select Tier</option>
                            {tierOptions.map((opt) => (
                              <option key={opt.value} value={opt.value}>
                                {opt.label}
                              </option>
                            ))}
                          </select>

                          <select
                            className="form-control"
                            value={selectedTags || ""}
                            onChange={(e) => onChangeTags(e)}
                          >
                            <option value="">Select Tag</option>
                            {tagListOption &&
                              tagListOption.map((opt, idx) => (
                                <option
                                  key={opt.value || idx}
                                  value={opt.value}
                                >
                                  {opt.label || opt.value}
                                </option>
                              ))}
                          </select>

                          <select
                            className="form-control"
                            disabled={!feature.checked}
                            defaultValue=""
                            onChange={(e) => onCouponAdd(e, index)}
                          >
                            <option value="">Select Coupons</option>
                            {couponList &&
                              couponList.map((opt, idx) => (
                                <option key={opt.id || idx} value={opt.id}>
                                  {opt.title || opt.label || opt.id}
                                </option>
                              ))}
                          </select>
                        </div>

                        <div className="partner-chip-row">
                          {selectedCoupons.map((item) => (
                            <div className="partner-chip" key={item.id}>
                              <span className="partner-chip-text">
                                {item.title || item.label || item.id}
                              </span>
                              <button
                                type="button"
                                className="partner-chip-remove"
                                onClick={() => onRemoveCoupon(item.id, index)}
                                aria-label="Remove coupon"
                              >
                                x
                              </button>
                            </div>
                          ))}
                        </div>
                      </>
                    );
                  })()}
                </div>
              ) : feature.label === "MBE Groups" && feature.checked ? (
                <div className="mbe-groups-block">
                  {(() => {
                    const groups = Array.isArray(groupData) ? groupData : [];
                    const selectedGroups = Array.isArray(feature.value)
                      ? feature.value
                      : [];

                    return (
                      <>
                        <div className="partner-row">
                          <select
                            className="form-control"
                            disabled={!feature.checked}
                            defaultValue=""
                            onChange={(e) => onGroupAdd(e, index)}
                          >
                            <option value="">SELECT Group</option>
                            {groups.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.group_name ||
                                  option.label ||
                                  option.name ||
                                  option.id}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="partner-chip-row">
                          {selectedGroups.map((item) => (
                            <div
                              className="partner-chip"
                              key={item.id || item.group_name}
                            >
                              <span className="partner-chip-text">
                                {item.group_name ||
                                  item.label ||
                                  item.name ||
                                  item.id}
                              </span>
                              <button
                                type="button"
                                className="partner-chip-remove"
                                onClick={() => onGroupRemove(item.id, index)}
                                aria-label="Remove group"
                              >
                                x
                              </button>
                            </div>
                          ))}
                        </div>
                      </>
                    );
                  })()}
                </div>
              ) : feature.label === "Claim Module" && feature.checked ? (
                <div className="claim-module-block">
                  {(() => {
                    const claimTypeOptions = [
                      { value: "per_employee", label: "Per Employee" },
                      { value: "per_claim", label: "Per Claim" },
                    ];
                    const claimBillingCycleOptions = [
                      { value: "monthly", label: "Monthly" },
                      { value: "weekly", label: "Weekly" },
                    ];

                    const claimData = {
                      claimValue: feature.claimValue || "",
                      claimType: feature.claimType || "",
                      claimPricingModel:
                        feature.claimPricingModel || "fixed_amount",
                      fixedClaimAmount: feature.fixedClaimAmount || "",
                      claimPricingSlabs:
                        feature.claimPricingSlabs &&
                        feature.claimPricingSlabs.length > 0
                          ? feature.claimPricingSlabs
                          : [
                              {
                                fromClaimCount: "",
                                toClaimCount: "",
                                price: "",
                              },
                            ],
                      maximumBillCount: feature.maximumBillCount || "",
                      maximumPrescriptionCount:
                        feature.maximumPrescriptionCount || "",
                      isUnlimitedClaim: feature.isUnlimitedClaim || false,
                      isSystemClaimAllowed:
                        feature.isSystemClaimAllowed || false,
                      isBankAccountNeeded: feature.isBankAccountNeeded || false,
                      isBankAccountDetailsDisable:
                        feature.isBankAccountDetailsDisable || false,
                      isBankChargeBorneByCustomer: isCheckedValue(
                        feature.isBankChargeBorneByCustomer,
                      ),
                      splitInvoicesByCompany: isCheckedValue(
                        feature.splitInvoicesByCompany,
                      ),
                      show_department: isCheckedValue(feature.show_department),
                      show_employee_id: isCheckedValue(
                        feature.show_employee_id,
                      ),
                      deliveryDeductFromClaim:
                        feature.deliveryDeductFromClaim === undefined
                          ? true
                          : isCheckedValue(feature.deliveryDeductFromClaim),
                      claimBillingCycle: feature.claimBillingCycle || "",
                      opdIndividualPrice: feature.opdIndividualPrice || "",
                      poolValue: feature.poolValue || "",
                      opdFamilyPrice: feature.opdFamilyPrice || "",
                      pharma: feature.pharma || "",
                      lab: feature.lab || "",
                      consult: feature.consult || "",
                      hospital: feature.hospital || "",
                      brokerEmail: feature.brokerEmail || "",
                      insuranceLogoFile: feature.insuranceLogoFile || "",
                      insuranceLogoUrl: feature.insuranceLogoUrl || "",
                      hospitalClaimContactNumber:
                        feature.hospitalClaimContactNumber || "",
                      isClaimMedicine: feature.isClaimMedicine || false,
                      isClaimLab: feature.isClaimLab || false,
                      isClaimRaya: feature.isClaimRaya || false,
                      isClaimTalkNow: feature.isClaimTalkNow || false,
                      isClaimTalkLater: feature.isClaimTalkLater || false,
                      isClaimTalkGlobal: feature.isClaimTalkGlobal || false,
                      isClaimEchanneling: feature.isClaimEchanneling || false,
                      isHospitalization: feature.isHospitalization || false,
                      isClaimFamily: feature.isClaimFamily || false,
                      isClaimMother: feature.isClaimMother || false,
                      isClaimFather: feature.isClaimFather || false,
                      isClaimSister: feature.isClaimSister || false,
                      isClaimBrother: feature.isClaimBrother || false,
                      isClaimSpouse: feature.isClaimSpouse || false,
                      isClaimChild: feature.isClaimChild || false,
                      policyShow:
                        feature.policyShow === undefined
                          ? true
                          : feature.policyShow,
                      ipdClaimValue: feature.ipdClaimValue || "",
                      bankCharge: feature.bankCharge || "",
                    };

                    return (
                      <>
                        <div className="claim-module-heading">
                          <div>
                            <h4>Claim configuration</h4>
                            <p>
                              Configure claim limits, billing, and eligible
                              services.
                            </p>
                          </div>
                          <span className="claim-status-badge">Enabled</span>
                        </div>

                        <section className="claim-panel">
                          <div className="claim-panel-heading">
                            <div>
                              <h5>Claim limits</h5>
                              <p>Set the usage limits for this catalogue.</p>
                            </div>
                          </div>
                          <div className="claim-fields-grid claim-fields-grid-four">
                            <div className="claim-field-group">
                              <label className="claim-field-label">
                                Claim Allocation
                              </label>
                              <FormControl
                                disabled={claimData.isUnlimitedClaim}
                                placeholder="Claim Allocation"
                                type="text"
                                className="claim-input"
                                value={claimData.claimValue}
                                onChange={(e) => {
                                  const re = /^[0-9\b]+$/;
                                  if (
                                    e.target.value === "" ||
                                    re.test(e.target.value)
                                  ) {
                                    updateClaimField(
                                      index,
                                      "claimValue",
                                      e.target.value,
                                    );
                                  }
                                }}
                              />
                              {claimValueError && (
                                <div className="error-message">
                                  {claimValueError}
                                </div>
                              )}
                              <p className="claim-field-help">
                                Allocation Limit for the each claim settlement.
                                This is the maximum amount that can be claimed
                                by the user.
                              </p>
                            </div>

                            <div className="claim-field-group">
                              <div className="claim-field-label-row">
                                <label className="claim-field-label">
                                  Bill Count
                                </label>
                                <span>Optional</span>
                              </div>
                              <FormControl
                                disabled={!feature.checked}
                                placeholder="Bill Count"
                                type="text"
                                className="claim-input"
                                value={claimData.maximumBillCount}
                                onChange={(e) => {
                                  const re = /^[0-9\b]+$/;
                                  if (
                                    e.target.value === "" ||
                                    re.test(e.target.value)
                                  ) {
                                    updateClaimField(
                                      index,
                                      "maximumBillCount",
                                      e.target.value,
                                    );
                                  }
                                }}
                              />
                              <p className="claim-field-help">
                                Allow bill count to be submitted for claim
                                settlement.
                              </p>
                            </div>

                            <div className="claim-field-group">
                              <div className="claim-field-label-row">
                                <label className="claim-field-label">
                                  Prescription Count
                                </label>
                                <span>Optional</span>
                              </div>
                              <FormControl
                                disabled={!feature.checked}
                                placeholder="Prescription Count"
                                type="text"
                                className="claim-input"
                                value={claimData.maximumPrescriptionCount}
                                onChange={(e) => {
                                  const re = /^[0-9\b]+$/;
                                  if (
                                    e.target.value === "" ||
                                    re.test(e.target.value)
                                  ) {
                                    updateClaimField(
                                      index,
                                      "maximumPrescriptionCount",
                                      e.target.value,
                                    );
                                  }
                                }}
                              />
                              <p className="claim-field-help">
                                allow prescription count to be submitted for
                                claim settlement.
                              </p>
                            </div>

                            <div className="claim-field-group">
                              <label className="claim-field-label">
                                Claim Type
                              </label>
                              <Select
                                isDisabled={!feature.checked}
                                className="claim-select"
                                placeholder="Claim Type"
                                value={claimTypeOptions.find(
                                  (opt) => opt.value === claimData.claimType,
                                )}
                                onChange={(selected) =>
                                  updateClaimField(
                                    index,
                                    "claimType",
                                    selected.value,
                                  )
                                }
                                options={claimTypeOptions}
                              />
                              <p className="claim-field-help">
                                Available settings update based on the selected
                                claim type.
                              </p>
                            </div>
                          </div>
                          {claimData.claimType === "per_claim" && (
                            <div className="claim-pricing-config">
                              <div className="claim-pricing-header">
                                <div>
                                  <label className="claim-section-label">
                                    Per claim pricing
                                  </label>
                                  <p className="claim-section-description">
                                    Configure a fixed amount or price tiers by
                                    claim count.
                                  </p>
                                </div>
                                <div className="claim-pricing-toggle">
                                  <button
                                    type="button"
                                    className={
                                      claimData.claimPricingModel ===
                                      "fixed_amount"
                                        ? "is-active"
                                        : ""
                                    }
                                    onClick={() =>
                                      updateClaimField(
                                        index,
                                        "claimPricingModel",
                                        "fixed_amount",
                                      )
                                    }
                                  >
                                    Fixed Amount
                                  </button>
                                  <button
                                    type="button"
                                    className={
                                      claimData.claimPricingModel ===
                                      "slab_pricing"
                                        ? "is-active"
                                        : ""
                                    }
                                    onClick={() =>
                                      updateClaimField(
                                        index,
                                        "claimPricingModel",
                                        "slab_pricing",
                                      )
                                    }
                                  >
                                    Slab Pricing
                                  </button>
                                </div>
                              </div>

                              {claimData.claimPricingModel ===
                              "fixed_amount" ? (
                                <div className="claim-pricing-fixed">
                                  <div className="claim-field-group">
                                    <label className="claim-field-label">
                                      Fixed Amount Per Claim
                                    </label>
                                    <FormControl
                                      disabled={!feature.checked}
                                      placeholder="Amount"
                                      type="text"
                                      className="claim-input"
                                      value={claimData.fixedClaimAmount}
                                      onChange={(e) => {
                                        const re = /^[0-9.]*$/;
                                        if (
                                          e.target.value === "" ||
                                          re.test(e.target.value)
                                        ) {
                                          updateClaimField(
                                            index,
                                            "fixedClaimAmount",
                                            e.target.value,
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                              ) : (
                                <div className="claim-pricing-slabs">
                                  {claimData.claimPricingSlabs.map(
                                    (slab, slabIndex) => (
                                      <div
                                        className="claim-pricing-slab-row"
                                        key={slabIndex}
                                      >
                                        <div className="claim-field-group">
                                          <label className="claim-field-label">
                                            From Claim
                                          </label>
                                          <FormControl
                                            disabled={!feature.checked}
                                            placeholder="1"
                                            type="text"
                                            className="claim-input"
                                            value={slab.fromClaimCount || ""}
                                            onChange={(e) => {
                                              const re = /^[0-9\b]+$/;
                                              if (
                                                e.target.value === "" ||
                                                re.test(e.target.value)
                                              ) {
                                                updateClaimPricingSlab(
                                                  index,
                                                  slabIndex,
                                                  "fromClaimCount",
                                                  e.target.value,
                                                );
                                              }
                                            }}
                                          />
                                        </div>
                                        <div className="claim-field-group">
                                          <label className="claim-field-label">
                                            To Claim
                                          </label>
                                          <FormControl
                                            disabled={!feature.checked}
                                            placeholder="50"
                                            type="text"
                                            className="claim-input"
                                            value={slab.toClaimCount || ""}
                                            onChange={(e) => {
                                              const re = /^[0-9\b]+$/;
                                              if (
                                                e.target.value === "" ||
                                                re.test(e.target.value)
                                              ) {
                                                updateClaimPricingSlab(
                                                  index,
                                                  slabIndex,
                                                  "toClaimCount",
                                                  e.target.value,
                                                );
                                              }
                                            }}
                                          />
                                        </div>
                                        <div className="claim-field-group">
                                          <label className="claim-field-label">
                                            Amount
                                          </label>
                                          <FormControl
                                            disabled={!feature.checked}
                                            placeholder="150"
                                            type="text"
                                            className="claim-input"
                                            value={slab.price || ""}
                                            onChange={(e) => {
                                              const re = /^[0-9.]*$/;
                                              if (
                                                e.target.value === "" ||
                                                re.test(e.target.value)
                                              ) {
                                                updateClaimPricingSlab(
                                                  index,
                                                  slabIndex,
                                                  "price",
                                                  e.target.value,
                                                );
                                              }
                                            }}
                                          />
                                        </div>
                                        <button
                                          type="button"
                                          className="claim-pricing-remove"
                                          onClick={() =>
                                            removeClaimPricingSlab(
                                              index,
                                              slabIndex,
                                            )
                                          }
                                        >
                                          x
                                        </button>
                                      </div>
                                    ),
                                  )}
                                  <button
                                    type="button"
                                    className="claim-pricing-add"
                                    onClick={() => addClaimPricingSlab(index)}
                                  >
                                    <i className="fa fa-plus"></i>
                                    Add Price Range
                                  </button>
                                </div>
                              )}
                            </div>
                          )}
                        </section>

                        <section className="claim-panel">
                          <div className="claim-panel-heading">
                            <div>
                              <h5>Claim behavior</h5>
                              <p>Choose how claims are handled and settled.</p>
                            </div>
                          </div>
                          <div className="claim-checkboxes-row">
                            <div
                              className={`claim-option-card ${claimData.isUnlimitedClaim ? "is-selected" : ""}`}
                            >
                              <CustomCheckbox
                                number={feature.id + 888}
                                checked={claimData.isUnlimitedClaim}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "isUnlimitedClaim",
                                    e.target.checked,
                                  )
                                }
                                label="Unlimited Allocation"
                              />
                              <p>No allocation limit will be applied.</p>
                            </div>
                            <div
                              className={`claim-option-card ${claimData.isSystemClaimAllowed ? "is-selected" : ""}`}
                            >
                              <CustomCheckbox
                                number={feature.id + 887}
                                checked={claimData.isSystemClaimAllowed}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "isSystemClaimAllowed",
                                    e.target.checked,
                                  )
                                }
                                label="Allow System Claim"
                              />
                              <p>
                                Allow system claims (claim orders) to be
                                created.
                              </p>
                            </div>
                            <div
                              className={`claim-option-card ${claimData.isBankAccountNeeded ? "is-selected" : ""}`}
                            >
                              <CustomCheckbox
                                number={feature.id + 886}
                                checked={claimData.isBankAccountNeeded}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "isBankAccountNeeded",
                                    e.target.checked,
                                  )
                                }
                                label="Bank Account Needed"
                              />
                              <p>A bank account is required for settlements.</p>
                            </div>
                            <div
                              className={`claim-option-card ${claimData.isBankAccountDetailsDisable ? "is-selected" : ""}`}
                            >
                              <CustomCheckbox
                                number={feature.id + 890}
                                checked={claimData.isBankAccountDetailsDisable}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "isBankAccountDetailsDisable",
                                    e.target.checked,
                                  )
                                }
                                label="Bank Account Details Disable"
                              />
                              <p>A bank account is Disable for this package.</p>
                            </div>
                            <div
                              className={`claim-option-card ${claimData.isBankChargeBorneByCustomer ? "is-selected" : ""}`}
                            >
                              <CustomCheckbox
                                number={feature.id + 885}
                                checked={claimData.isBankChargeBorneByCustomer}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "isBankChargeBorneByCustomer",
                                    e.target.checked,
                                  )
                                }
                                label="Customer Bears Bank Charge"
                              />
                              <p>The customer will bear the bank charges.</p>
                            </div>
                            <div
                              className={`claim-option-card ${claimData.splitInvoicesByCompany ? "is-selected" : ""}`}
                            >
                              <CustomCheckbox
                                number={feature.id + 889}
                                checked={claimData.splitInvoicesByCompany}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "splitInvoicesByCompany",
                                    e.target.checked,
                                  )
                                }
                                label="Split Invoices By Company"
                              />
                              <p>Invoices will be separated by company.</p>
                            </div>
                            <div
                              className={`claim-option-card ${claimData.deliveryDeductFromClaim ? "is-selected" : ""}`}
                            >
                              <CustomCheckbox
                                number={feature.id + 884}
                                checked={claimData.deliveryDeductFromClaim}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "deliveryDeductFromClaim",
                                    e.target.checked,
                                  )
                                }
                                label="Deduct Delivery From Claim"
                              />
                              <p>
                                Delivery charges will be deducted from claim.
                              </p>
                            </div>
                          </div>
                        </section>

                        <section className="claim-panel">
                          <div className="claim-panel-heading">
                            <div>
                              <h5>Billing &amp; allocation</h5>
                              <p>
                                Define billing frequency and monetary limits.
                              </p>
                            </div>
                          </div>
                          <div className="claim-fields-grid claim-billing-grid">
                            <div className="claim-field-group">
                              <label className="claim-field-label">
                                Billing Cycle
                              </label>
                              <Select
                                isDisabled={!feature.checked}
                                className="claim-select"
                                placeholder="Billing Cycle"
                                value={claimBillingCycleOptions.find(
                                  (opt) =>
                                    opt.value == claimData.claimBillingCycle,
                                )}
                                onChange={(selected) =>
                                  updateClaimField(
                                    index,
                                    "claimBillingCycle",
                                    selected.value,
                                  )
                                }
                                options={claimBillingCycleOptions}
                              />
                            </div>

                            <div className="claim-field-group">
                              <label className="claim-field-label">
                                OPD Price
                              </label>
                              <FormControl
                                disabled={!feature.checked}
                                placeholder="Individual Price"
                                type="text"
                                className="claim-input"
                                value={claimData.opdIndividualPrice}
                                onChange={(e) => {
                                  const re = /^[0-9\b]+$/;
                                  if (
                                    e.target.value === "" ||
                                    re.test(e.target.value)
                                  ) {
                                    updateClaimField(
                                      index,
                                      "opdIndividualPrice",
                                      e.target.value,
                                    );
                                  }
                                }}
                              />
                            </div>

                            <div className="claim-field-group">
                              <label className="claim-field-label">
                                Pool Limit
                              </label>
                              <FormControl
                                disabled={!feature.checked}
                                placeholder="Pool Limit"
                                type="text"
                                className="claim-input"
                                value={claimData.poolValue}
                                onChange={(e) => {
                                  const re = /^[0-9\b]+$/;
                                  if (
                                    e.target.value === "" ||
                                    re.test(e.target.value)
                                  ) {
                                    updateClaimField(
                                      index,
                                      "poolValue",
                                      e.target.value,
                                    );
                                  }
                                }}
                              />
                            </div>

                            <div className="claim-field-group">
                              <label className="claim-field-label">
                                Family Allocation
                              </label>
                              <FormControl
                                disabled={
                                  !feature.checked || !claimData.isClaimFamily
                                }
                                placeholder="Family Allocation"
                                type="text"
                                className="claim-input"
                                value={claimData.opdFamilyPrice}
                                onChange={(e) =>
                                  updateClaimField(
                                    index,
                                    "opdFamilyPrice",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>
                            <div className="claim-field-group">
                              <label className="claim-field-label">
                                Bank Charge
                              </label>
                              <FormControl
                                disabled={!feature.checked}
                                placeholder="Bank Charge"
                                type="text"
                                className="claim-input"
                                value={claimData.bankCharge || ""}
                                onChange={(e) => {
                                  const re = /^[0-9\b]+$/;
                                  if (
                                    e.target.value === "" ||
                                    re.test(e.target.value)
                                  ) {
                                    updateClaimField(
                                      index,
                                      "bankCharge",
                                      e.target.value,
                                    );
                                  }
                                }}
                              />
                              {bankChargeError && (
                                <div className="error-message">
                                  {bankChargeError}
                                </div>
                              )}
                            </div>
                          </div>
                        </section>

                        <section className="claim-panel">
                          <div className="claim-panel-heading">
                            <div>
                              <h5>Other section</h5>
                              <p>Configure additional Report details.</p>
                            </div>
                          </div>
                          <div className="claim-fields-grid claim-other-grid">
                            <div className="claim-field-group">
                              <label className="claim-field-label">
                                Report Url
                              </label>
                              <FormControl
                                disabled={!feature.checked}
                                placeholder="Enter report url"
                                type="text"
                                className="claim-input"
                                value={dashboardUrl || ""}
                                onChange={(e) =>
                                  setDashboardUrl(e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </section>
                        <section className="claim-panel">
                          <div className="claim-panel-heading">
                            <div>
                              <h5>Invoice Structure Configuration</h5>
                              <p>
                                Choose the employee details shown on utilization
                                invoices.
                              </p>
                            </div>
                          </div>
                          <div className="claim-checkboxes-row">
                            <div
                              className={`claim-option-card ${claimData.show_department ? "is-selected" : ""}`}
                            >
                              <CustomCheckbox
                                number={feature.id + 891}
                                checked={claimData.show_department}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "show_department",
                                    e.target.checked,
                                  )
                                }
                                label="Show Department"
                              />
                              <p>
                                Show the employee department on the invoice.
                              </p>
                            </div>
                            <div
                              className={`claim-option-card ${claimData.show_employee_id ? "is-selected" : ""}`}
                            >
                              <CustomCheckbox
                                number={feature.id + 892}
                                checked={claimData.show_employee_id}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "show_employee_id",
                                    e.target.checked,
                                  )
                                }
                                label="Show Employee ID"
                              />
                              <p>Show the employee ID on the invoice.</p>
                            </div>
                          </div>
                        </section>

                        <div className="claim-bottom-grid">
                          <div className="claim-section claim-section--compact">
                            <label className="claim-section-label">
                              Manual claim features
                            </label>
                            <p className="claim-section-description">
                              Select services available for manual claims.
                            </p>
                            <div className="claim-checkboxes-grid claim-compact-grid">
                              <CustomCheckbox
                                disabled={!feature.checked}
                                number={feature.id + 900}
                                checked={claimData.pharma === "Pharma"}
                                onChange={(e) =>
                                  updateClaimField(
                                    index,
                                    "pharma",
                                    e.target.checked ? "Pharma" : "",
                                  )
                                }
                                label="Pharma"
                              />
                              <CustomCheckbox
                                disabled={!feature.checked}
                                number={feature.id + 90}
                                checked={claimData.lab === "Lab"}
                                onChange={(e) =>
                                  updateClaimField(
                                    index,
                                    "lab",
                                    e.target.checked ? "Lab" : "",
                                  )
                                }
                                label="Lab"
                              />
                              <CustomCheckbox
                                disabled={!feature.checked}
                                number={feature.id + 91}
                                checked={claimData.consult === "Consult"}
                                onChange={(e) =>
                                  updateClaimField(
                                    index,
                                    "consult",
                                    e.target.checked ? "Consult" : "",
                                  )
                                }
                                label="Consult"
                              />
                              <CustomCheckbox
                                disabled={!feature.checked}
                                number={feature.id + 92}
                                checked={claimData.hospital === "Hospital"}
                                onChange={(e) =>
                                  updateClaimField(
                                    index,
                                    "hospital",
                                    e.target.checked ? "Hospital" : "",
                                  )
                                }
                                label="Hospital"
                              />
                              {claimData.hospital === "Hospital" && (
                                <>
                                  <div className="claim-field-group">
                                    <FormControl
                                      // disabled={claimData.isUnlimitedClaim}
                                      placeholder="IPD Claim Allocation"
                                      type="text"
                                      className="claim-input"
                                      value={claimData.ipdClaimValue || ""}
                                      onChange={(e) => {
                                        const re = /^[0-9\b]+$/;
                                        if (
                                          e.target.value === "" ||
                                          re.test(e.target.value)
                                        ) {
                                          updateClaimField(
                                            index,
                                            "ipdClaimValue",
                                            e.target.value,
                                          );
                                        }
                                      }}
                                    />
                                    {ipdClaimValueError && (
                                      <div className="error-message">
                                        {ipdClaimValueError}
                                      </div>
                                    )}
                                  </div>
                                  <div className="claim-field-group">
                                    <FormControl
                                      disabled={!feature.checked}
                                      placeholder="Broker Email"
                                      type="email"
                                      className="claim-input"
                                      value={claimData.brokerEmail || ""}
                                      onChange={(e) =>
                                        updateClaimField(
                                          index,
                                          "brokerEmail",
                                          e.target.value,
                                        )
                                      }
                                    />
                                    {brokerEmailError && (
                                      <div className="error-message">
                                        {brokerEmailError}
                                      </div>
                                    )}
                                  </div>
                                  <div className="claim-field-group">
                                    <input
                                      style={{ display: "none" }}
                                      id={`insurance_logo_${feature.id}`}
                                      type="file"
                                      accept="image/*"
                                      onChange={(e) =>
                                        updateClaimField(
                                          index,
                                          "insuranceLogoFile",
                                          e.target.files[0] || "",
                                        )
                                      }
                                    />
                                    <button
                                      type="button"
                                      className="claim-upload-button"
                                      disabled={!feature.checked}
                                      onClick={() =>
                                        document
                                          .getElementById(
                                            `insurance_logo_${feature.id}`,
                                          )
                                          .click()
                                      }
                                    >
                                      <i
                                        className={
                                          claimData.insuranceLogoFile ||
                                          claimData.insuranceLogoUrl
                                            ? "fa fa-pencil fa-fw"
                                            : "fa fa-plus"
                                        }
                                      ></i>
                                      {claimData.insuranceLogoFile ||
                                      claimData.insuranceLogoUrl
                                        ? "Change Insurance Logo"
                                        : "Choose Insurance Logo"}
                                    </button>
                                    {claimData.insuranceLogoFile && (
                                      <span className="claim-upload-status">
                                        {claimData.insuranceLogoFile.name}
                                      </span>
                                    )}
                                    {claimData.insuranceLogoUrl &&
                                      !claimData.insuranceLogoFile && (
                                        <img
                                          className="claim-upload-preview"
                                          src={claimData.insuranceLogoUrl}
                                          alt="Insurance Logo"
                                        />
                                      )}
                                  </div>
                                  <div className="claim-field-group claim-phone-field">
                                    <div className="claim-phone-input">
                                      <div className="claim-phone-prefix">
                                        +94
                                      </div>
                                      <FormControl
                                        disabled={!feature.checked}
                                        placeholder="Hospital claim contact no"
                                        type="tel"
                                        inputMode="tel"
                                        maxLength={20}
                                        className="claim-input claim-phone-number"
                                        value={
                                          claimData.hospitalClaimContactNumber ||
                                          ""
                                        }
                                        onChange={(e) => {
                                          const re = /^[0-9+\-\s\b]+$/;
                                          if (
                                            e.target.value === "" ||
                                            re.test(e.target.value)
                                          ) {
                                            updateClaimField(
                                              index,
                                              "hospitalClaimContactNumber",
                                              e.target.value,
                                            );
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>

                          <div className="claim-section claim-section--compact">
                            <label className="claim-section-label">
                              Claim categories
                            </label>
                            <p className="claim-section-description">
                              Choose the services eligible for this claim.
                            </p>
                            <div className="claim-checkboxes-grid claim-compact-grid claim-category-grid">
                              <CustomCheckbox
                                disabled={!feature.checked}
                                number={feature.id + 799}
                                checked={claimData.isClaimMedicine}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "isClaimMedicine",
                                    e.target.checked,
                                  )
                                }
                                label="Medicine"
                              />
                              <CustomCheckbox
                                disabled={!feature.checked}
                                number={feature.id + 802}
                                checked={claimData.isClaimLab}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "isClaimLab",
                                    e.target.checked,
                                  )
                                }
                                label="Lab"
                              />
                              <CustomCheckbox
                                disabled={!feature.checked}
                                number={feature.id + 803}
                                checked={claimData.isClaimRaya}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "isClaimRaya",
                                    e.target.checked,
                                  )
                                }
                                label="Raya"
                              />
                              <CustomCheckbox
                                disabled={!feature.checked}
                                number={feature.id + 804}
                                checked={claimData.isClaimTalkNow}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "isClaimTalkNow",
                                    e.target.checked,
                                  )
                                }
                                label="Talk Now"
                              />
                              <CustomCheckbox
                                disabled={!feature.checked}
                                number={feature.id + 805}
                                checked={claimData.isClaimTalkLater}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "isClaimTalkLater",
                                    e.target.checked,
                                  )
                                }
                                label="Talk Later"
                              />
                              <CustomCheckbox
                                disabled={!feature.checked}
                                number={feature.id + 806}
                                checked={claimData.isClaimTalkGlobal}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "isClaimTalkGlobal",
                                    e.target.checked,
                                  )
                                }
                                label="Talk Global"
                              />
                              <CustomCheckbox
                                disabled={!feature.checked}
                                number={feature.id + 901}
                                checked={claimData.isClaimEchanneling}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "isClaimEchanneling",
                                    e.target.checked,
                                  )
                                }
                                label="E-Channeling"
                              />
                              <CustomCheckbox
                                disabled={!feature.checked}
                                number={feature.id + 903}
                                checked={claimData.isHospitalization}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "isHospitalization",
                                    e.target.checked,
                                  )
                                }
                                label="Hospitalization"
                              />
                              <CustomCheckbox
                                disabled={!feature.checked}
                                number={feature.id + 809}
                                checked={claimData.isClaimFamily}
                                onChange={(e) =>
                                  toggleClaimCheckbox(
                                    index,
                                    "isClaimFamily",
                                    e.target.checked,
                                  )
                                }
                                label="Family"
                              />
                            </div>

                            {claimData.isClaimFamily && (
                              <div className="claim-family-section">
                                <label className="claim-subsection-label">
                                  Select the beneficiary
                                </label>
                                <div className="claim-checkboxes-grid">
                                  <CustomCheckbox
                                    disabled={!feature.checked}
                                    number={feature.id + 808}
                                    checked={claimData.isClaimMother}
                                    onChange={(e) =>
                                      toggleClaimCheckbox(
                                        index,
                                        "isClaimMother",
                                        e.target.checked,
                                      )
                                    }
                                    label="Mother"
                                  />
                                  <CustomCheckbox
                                    disabled={!feature.checked}
                                    number={feature.id + 807}
                                    checked={claimData.isClaimFather}
                                    onChange={(e) =>
                                      toggleClaimCheckbox(
                                        index,
                                        "isClaimFather",
                                        e.target.checked,
                                      )
                                    }
                                    label="Father"
                                  />
                                  <CustomCheckbox
                                    disabled={!feature.checked}
                                    number={feature.id + 810}
                                    checked={claimData.isClaimSister}
                                    onChange={(e) =>
                                      toggleClaimCheckbox(
                                        index,
                                        "isClaimSister",
                                        e.target.checked,
                                      )
                                    }
                                    label="Sister"
                                  />
                                  <CustomCheckbox
                                    disabled={!feature.checked}
                                    number={feature.id + 811}
                                    checked={claimData.isClaimBrother}
                                    onChange={(e) =>
                                      toggleClaimCheckbox(
                                        index,
                                        "isClaimBrother",
                                        e.target.checked,
                                      )
                                    }
                                    label="Brother"
                                  />
                                  <CustomCheckbox
                                    disabled={!feature.checked}
                                    number={feature.id + 812}
                                    checked={claimData.isClaimSpouse}
                                    onChange={(e) =>
                                      toggleClaimCheckbox(
                                        index,
                                        "isClaimSpouse",
                                        e.target.checked,
                                      )
                                    }
                                    label="Spouse"
                                  />
                                  <CustomCheckbox
                                    disabled={!feature.checked}
                                    number={feature.id + 813}
                                    checked={claimData.isClaimChild}
                                    onChange={(e) =>
                                      toggleClaimCheckbox(
                                        index,
                                        "isClaimChild",
                                        e.target.checked,
                                      )
                                    }
                                    label="Child"
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {(claimData.isClaimTalkGlobal ||
                          claimData.isClaimTalkLater ||
                          claimData.isClaimTalkNow ||
                          claimData.isClaimRaya ||
                          claimData.isClaimLab ||
                          claimData.isClaimMedicine) && (
                          <div className="claim-policy-section">
                            <CustomCheckbox
                              disabled={!feature.checked}
                              number={feature.id + 904}
                              checked={claimData.policyShow}
                              onChange={(e) =>
                                toggleClaimCheckbox(
                                  index,
                                  "policyShow",
                                  e.target.checked,
                                )
                              }
                              label="Policy Show"
                            />
                            <label className="claim-section-label">
                              Claim Policy Details
                            </label>
                            <Editor
                              editorState={
                                feature.claimPolicyDetails &&
                                feature.claimPolicyDetails.value
                              }
                              editorClassName="terms-editor"
                              onEditorStateChange={(editorState) => {
                                updatePolicyField(
                                  index,
                                  "medicine",
                                  editorState,
                                );
                              }}
                            />
                          </div>
                        )}
                      </>
                    );
                  })()}
                </div>
              ) : feature.label === "Talk Later Doctor wise" &&
                feature.checked ? (
                <>
                  {(Array.isArray(feature.input_value)
                    ? feature.input_value
                    : []
                  ).map((doctor, docIdx) => (
                    <div className="speciality-row" key={docIdx}>
                      <Select
                        placeholder="Select Doctor"
                        options={doctorListOption}
                        className="speciality-select"
                        classNamePrefix="select"
                        value={doctor.doctors || null}
                        onChange={(selected) =>
                          onDoctorChange(selected, index, docIdx)
                        }
                      />
                      <FormControl
                        type="text"
                        placeholder="Number of Calls"
                        className="form-control speciality-input"
                        value={doctor.no_of_calls || ""}
                        onChange={(e) => onDoctorCallChange(e, index, docIdx)}
                      />
                      <div className="speciality-actions">
                        <button
                          type="button"
                          className="speciality-btn speciality-close"
                          onClick={() => removeDoctorRow(index, docIdx)}
                        >
                          <i className="fa fa-close"></i>
                        </button>
                        {docIdx === (feature.input_value || []).length - 1 && (
                          <button
                            type="button"
                            className="speciality-btn speciality-add"
                            onClick={() => addDoctorRow(index)}
                          >
                            Add
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                feature.checked && (
                  <>
                    <div className="feature-input">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={feature.placeholder}
                        value={feature.input_value}
                        onChange={(e) => {
                          if (
                            e.target.value === "" ||
                            /^[0-9\b]+$/.test(e.target.value)
                          ) {
                            const updatedFeatures = [...featureDetails];
                            updatedFeatures[index].input_value = e.target.value;
                            setFeatureDetails(updatedFeatures);
                          }
                        }}
                      />
                    </div>
                    {feature.isFlashCredit !== undefined && (
                      <div className="flash-credit-control">
                        <label
                          className="flash-credit-toggle"
                          htmlFor={`featureFlashCredit-${feature.id + 1}`}
                          title="Mark as Flash Credit"
                        >
                          <input
                            type="checkbox"
                            id={`featureFlashCredit-${feature.id + 1}`}
                            checked={feature.isFlashCredit}
                            onChange={(e) => {
                              const updatedFeatures = [...featureDetails];
                              updatedFeatures[index].isFlashCredit =
                                e.target.checked;
                              setFeatureDetails(updatedFeatures);
                            }}
                            disabled={feature.unlimited}
                          />
                          <span
                            className="flash-credit-box"
                            aria-hidden="true"
                          />
                          <span className="flash-credit-text">
                            Flash Credit
                          </span>
                        </label>
                      </div>
                    )}
                    {feature.unlimited !== undefined && (
                      <div className="flash-credit-control">
                        <label
                          className="flash-credit-toggle"
                          htmlFor={`featureUnlimited-${feature.id + 2}`}
                          title="Mark as Flash Credit"
                        >
                          <input
                            type="checkbox"
                            id={`featureUnlimited-${feature.id + 2}`}
                            checked={feature.unlimited}
                            onChange={(e) => {
                              const updatedFeatures = [...featureDetails];
                              updatedFeatures[index].unlimited =
                                e.target.checked;
                              if (e.target.checked) {
                                updatedFeatures[index].input_value =
                                  "unlimited";
                              } else {
                                updatedFeatures[index].input_value = "";
                              }
                              setFeatureDetails(updatedFeatures);
                            }}
                            disabled={feature.isFlashCredit}
                          />
                          <span
                            className="flash-credit-box"
                            aria-hidden="true"
                          />
                          <span className="flash-credit-text">Unlimited</span>
                        </label>
                      </div>
                    )}
                  </>
                )
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
    // </div>
    // </div>
  );
};

export default CataloguePackageFeatureDetailsForm;
